import { render, staticRenderFns } from "./GChatPageHeader.vue?vue&type=template&id=effb6d3e&scoped=true&"
import script from "./GChatPageHeader.vue?vue&type=script&lang=ts&"
export * from "./GChatPageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GChatPageHeader.vue?vue&type=style&index=0&id=effb6d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effb6d3e",
  null
  
)

export default component.exports